import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { FlowsModule } from '../dashboard/flows/flows.module';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './main-dashboard/dashboard.component';

@NgModule({
  declarations: [DashboardComponent],
  imports: [
    DashboardRoutingModule,
    FlowsModule,
    SharedModule,
  ]
})
export class DashboardModule { }
